import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Package, Recycle, Scale } from 'lucide-react';
import PantryStaplesControl from './PantryStaplesControl';
import LeftoversControl from './LeftoversControl';
import SmartRoundingPreview from './SmartRoundingPreview';

const PantryWasteControls = () => {
  const [activeTab, setActiveTab] = useState('staples');

  return (
    <div className="space-y-4" data-testid="pantry-waste-controls">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Smart Shopping Controls</h2>
          <p className="text-sm text-muted-foreground">
            Reduce waste and shop smarter
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="staples" className="flex items-center gap-2">
            <Package className="w-4 h-4" />
            <span className="hidden sm:inline">Staples</span>
          </TabsTrigger>
          <TabsTrigger value="leftovers" className="flex items-center gap-2">
            <Recycle className="w-4 h-4" />
            <span className="hidden sm:inline">Leftovers</span>
          </TabsTrigger>
          <TabsTrigger value="rounding" className="flex items-center gap-2">
            <Scale className="w-4 h-4" />
            <span className="hidden sm:inline">Rounding</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="staples" className="mt-4">
          <PantryStaplesControl />
        </TabsContent>

        <TabsContent value="leftovers" className="mt-4">
          <LeftoversControl />
        </TabsContent>

        <TabsContent value="rounding" className="mt-4">
          <SmartRoundingPreview />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PantryWasteControls;
